<template>
  <div class="infobox">
    <p><b>Geschafft!</b></p>
    <p>Du hast <b>{{score}}</b> Punkte erspielt!</p>
    <button @click="$emit('start-game')">Erneut spielen</button>
  </div>
</template>

<script>
  export default {
    name: 'ScoreTable',
    props: {
      score: Number
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ScoreTable.vue